export enum NoUpdateTaskTitles {
  FinalDeliveryAddress = 'Final Delivery Address(es) Required',
  PackageInformation = 'Package Information Required',
  PickUpAddress = 'Pick-up Address Required',
  ExporterAddress = 'Exporter Details Required',
}
